/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rewards_Page_Meta_TitleInputs */

const en_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewards | Glider`)
};

const de_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prämien | Glider`)
};

const pt_br2_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas | Glider`)
};

const tr_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödüller | Glider`)
};

const zh_cn2_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`奖励 | Glider`)
};

const zh_hk2_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獎賞 | Glider`)
};

const ko_kr2_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드 | Glider`)
};

const ru_ru2_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вознаграждения | Glider`)
};

const es_419_rewards_page_meta_title = /** @type {(inputs: Rewards_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas | Glider`)
};

/**
* | output |
* | --- |
* | "Rewards \| Glider" |
*
* @param {Rewards_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const rewards_page_meta_title = /** @type {((inputs?: Rewards_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rewards_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rewards_page_meta_title(inputs)
	if (locale === "de") return de_rewards_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_rewards_page_meta_title(inputs)
	if (locale === "tr") return tr_rewards_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_rewards_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_rewards_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_rewards_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_rewards_page_meta_title(inputs)
	return es_419_rewards_page_meta_title(inputs)
});